export enum PatientSources {
    none = 0,
    outPatientDepartment = 1,
    emergency = 2,
    lab = 3,
    pharmacy = 4,
}